import ConfigServices from "../../services/Config.services";

export const getWhiteLabelDictionary = (key, title) => {
    const whiteLabel = getWhitelabel();
    if (ConfigServices._whiteLabelDictionary[whiteLabel]) {
        const mainDictionary = ConfigServices._whiteLabelDictionary[whiteLabel];
        if (mainDictionary[key]) return mainDictionary[key]
    }
    return title
}

const getWhitelabel = () => {
    return process.env.REACT_APP_WHITELABEL
}
export default getWhitelabel